import { apiFetch } from "../utils/apiFetch"

export type PatOrgAkteResult = {
  status: "SYNCED" | "ERROR" | "SKIPPED"
  message?: string
}

// Admins only: tries the PatOrg file of a paid application again
export function retryPatOrgAkte(kind: "trademark" | "design" | "patent", id: string) {
  return apiFetch(`/api/patorg/akte/${kind}/${id}`, { method: "POST" }) as Promise<PatOrgAkteResult>
}
